import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, createContext, useContext } from "react";
import * as IconPalette from "./IconPalette";
export const IconContext = createContext(IconPalette);
IconContext.displayName = "IconContext";
export function useIconPalette() {
    return useContext(IconContext);
}
export function useIcon(icon) {
    var _a;
    const palette = useIconPalette();
    return (_a = palette[icon]) !== null && _a !== void 0 ? _a : IconFallback;
}
function IconFallback() {
    return _jsx(Fragment, {});
}
//# sourceMappingURL=IconProvider.js.map